import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { combineReducers, createStore } from 'redux';
import AppWrapper from './layout/AppWrapper';
import userReducer from './redux/reducers/userReducer';
import reportWebVitals from './reportWebVitals';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);
const reducers = {
    userReducer
}
const store = createStore(combineReducers(reducers));
root.render(
    <React.StrictMode>
        <ToastContainer />
        <BrowserRouter>
            <Provider store={store}>
                <AppWrapper></AppWrapper>
            </Provider>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
